import React from 'react';

const Container = ({ children }) => {
  return <div>{children}</div>;
};

export default Container;
